<template>
<v-container>
    

    <v-divider class="mt-12"></v-divider>
    <h2 class="text-center">Productos {{$route.params.linea}} {{$route.params.cate}} {{$route.params.nombre}} </h2>
    <v-divider></v-divider>

    <v-btn 
    block
    class="mx-auto"
    color="success" 
    dark @click.stop="nombre='',
    intervalo='',
    picture='',
    $store.commit('dialogoProductohijo')" >
    Nuevo Item</v-btn>

      <agregaProductoHijo
      :Nombre="nombre"
      :picture="picture"
      :color="color"
      :intervalo="intervalo"
      :linea="$route.params.linea"
      :categoria="$route.params.cate"
      :productopadre="$route.params.nombre"
      />

    <v-layout row wrap pa-2>

        <v-flex xs12 class="pa-2">
                        <v-row  no-gutters>
                    <v-col
                        v-for="cate in filtra($route.params.cate)"  v-bind:key="cate['.key']"
                        cols="6"
                        xs="6"
                        sm="4"
                        md="3">

                        <v-card
                        class="pa-3 font-italic text-center"
                        outlined
                        :color="cate.color"
                        tile
                        >{{cate.nombre}}
                                <v-img
                                :src="cate.foto"
                                aspect-ratio="1"
                                class="text-left"
                                >
                                <p>
                        <router-link 
                        :to="/gestionfotoshijo/+$route.params.linea+'/'+$route.params.cate+'/'+$route.params.nombre+'/'+cate.nombre"  > 
                                <v-btn icon color="error">
                                <v-icon>fas fa-camera</v-icon>
                                </v-btn>
                                 </router-link>
                                </p>
                                <p> 
                                <v-btn icon color="error"
                                @click.stop="nombre=cate.nombre,
                                picture=cate.foto,
                                intervalo=cate.intervalo,
                                $store.commit('colorelegido',cate.color),
                                 $store.commit('dialogoProductohijo')">
                                <v-icon>fas fa-wrench</v-icon>
                                </v-btn>
                                </p>
                                <template v-slot:placeholder>
                                    <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                                </v-img>
                                    
                                 <v-btn icon color="pink">
                                <v-icon>fas fa-plus</v-icon>
                                </v-btn>
                 

                        </v-card>
                    </v-col>
                    </v-row>
        </v-flex>
    </v-layout>
 
</v-container>
</template>

<script>
// @ is an alias to /src

import agregaProductoHijo from '@/components/agregaProductoHijo'
import { db } from '../db'

export default {
  name: 'gestionCategorias',
      
    firebase: {
        productos: db.database().ref("productosHijo"),

    },
    components: {
        agregaProductoHijo,
    },

    data() {
        return{
    productos:[],
    nombre:'',
    picture:'',
    intervalo:''

    }
    },
    methods: {
        filtra(cat){
            var cate = []
            var rr
            for(var i=0;i<this.productos.length;i++){
                if(this.productos[i].categoria==cat){
                  cate.push(this.productos[i])
                }
            }
               return cate
        },
        }
  
}
</script>
